import { createFileRoute } from "@tanstack/react-router"
import { createFormViewStaticData } from "src/views/CreateFormView/constants"
import { CreateFormView } from "src/views/CreateFormView/CreateFormView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/create")({
	component: CreateFormView,
	staticData: createFormViewStaticData,
})
